import React, { useEffect, useState, useMemo } from 'react';
import InputMask from "react-input-mask";
import DatalistInput from 'react-datalist-input';
import 'react-datalist-input/dist/styles.css';
import Functions from './Functions'
import { toast } from 'react-toastify';
import Api from '../services/Api'
import { useTranslation } from 'react-i18next';
import { useCountry } from '../contexts/CountryContext';
import { formatDocument, formatPhone } from '../config/countries';

const ListItemCustomer = (props) => {
  const { t } = useTranslation();
  const { countryConfig } = useCountry();
  //{ id, user, view, name, description, thumbnail, CNPJ, state, city, address, razaoSocial, keyPIX, plan, plans, active, onDelete, loadItem, setEditCustomer, props.setLoading }
  const [toggleItem, setToggleItem] = useState([]);
  const [formState, setFormState] = useState({
    _id: `${props._id}`,
    name: `${props.name}`,
    birthDate: `${props.birthDate}`,
    thumbnail: `${props.thumbnail}`,
    gender: `${props.gender}`,
    bloodType: `${props.bloodType}`,
    phone: `${props.phone}`,
    cpf: `${props.cpf}`,
    email: `${props.email}`,
    height: `${props.height}`,
    weight: `${props.weight}`,
    address: props.address,
    observations: `${props.observations}`,
    active: `${props.active}`
  });

  // Executa assim q a página é aberta;
  useEffect(() => {
    console.log(props.observations);
    if(props.view === "EvaluateIris") {
      props.setCanEditCustomer(false);
    }
  }, []);

  const allCustumers = useMemo(() =>
    props?.customers && props.customers.map((item) => ({
        value: item.name,
        id: item._id,
        ...item,
      })),
    [props?.customers]
  );

  // useMemo: executa quando determinado estado for alterado, neste caso o estado 'formState.thumbnail'
  /*const preview = useMemo(() => {
    if(props.thumbnail !== "" && props.thumbnail === formState.thumbnail){
      return props.thumbnail;
    } else {
      return formState.thumbnail ? URL.createObjectURL(formState.thumbnail) : null;
    }
  }, [formState.thumbnail]);*/
  
  function onChangeThumbnailFile(e){
    const file = e.target.files[0];
    if(file){
      setFormState({
        ...formState,
        thumbnail: file
      });
    }
  };

  function onSelectCustomer(customerSelected){
    const data = {
      ...formState, 
      _id: customerSelected._id,
      name: customerSelected.name,
      birthDate: customerSelected.birthDate ? customerSelected.birthDate : "",
      thumbnail: customerSelected?.thumbnail ? customerSelected.thumbnail : "",
      gender: customerSelected?.gender ? customerSelected.gender : "",
      phone: customerSelected?.phone ? customerSelected.phone : "",
      cpf: customerSelected?.cpf ? customerSelected.cpf : "",
      email: customerSelected?.email ? customerSelected.email : "",
      height: customerSelected?.height ? customerSelected.height : "",
      weight: customerSelected?.weight ? customerSelected.weight : "",
      bloodType:  customerSelected?.bloodType ? customerSelected.bloodType : "",
      address: customerSelected?.address ? customerSelected.address : {street: "", number:"", district: "", complement: "", city: "", state: ""},
      observations: customerSelected?.observations ? customerSelected.observations : "",
      active: customerSelected.active,
      //id: e.target.value.indexOf("-") !== -1 ? e.target.value.split("-")[0] : "", 
      //name: e.target.value.indexOf("-") !== -1 ? e.target.value.split("-")[1] : e.target.value
    }
    setFormState(data);
    props.setCanEditCustomer(false);
    props.onChangeCustomer(data);
  }

  async function handleSubmit(e){
    e.preventDefault();
    try {
      props.setLoading(true);
      const data = new FormData();
      data.append('id', formState._id);
      data.append('business', props.business);
      data.append('name', formState.name);
      data.append('birthDate', formState.birthDate);
      data.append('gender', formState.gender);
      data.append('phone', formState.phone);
      data.append('cpf', formState.cpf);
      data.append('email', formState.email);
      data.append('height', formState.height);
      data.append('weight', formState.weight);
      data.append('bloodType', formState.bloodType);
      data.append('observations', formState.observations);
      data.append('address', JSON.stringify(formState.address));

      const response = await Api.post("/update-customer", data);
      if(response.hasOwnProperty('_id') || response.hasOwnProperty('ok')){
        toast.success(t('dashboardCustomers.notifications.success'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        if(props.view === "EvaluateIris"){
          props.setCanEditCustomer(false);
          setFormState(response?._id ? response : formState)
          props.onChangeCustomer(response?._id ? response : formState);
        } else {
          setToggleItem([]);
          const reloadItem = props.loadItem;
          reloadItem();
        }
        props.setLoading(false);
      } else {
        toast.error(t('dashboardCustomers.notifications.error'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        props.setLoading(false);
      }
    } catch (error) {
      toast.error(t('dashboardCustomers.notifications.error'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      props.setLoading(false);
    }
  }
  
  return (
      <li className={"itemDashboardList dashboardEditCustomer"} style={{listStyle: 'none'}}>
        {props.view === "DashboardCustomer" ?
          <div className="row v-center headList" onClick={() => {toggleItem[0] !== props._id ? setToggleItem([props._id]) : setToggleItem([])}}>
            <div className="col-10">
              <span>{formState.name}</span>
            </div>
            <div className="col-2 text-right">
              <span className={`iconItem ${toggleItem[0] === props._id ? 'fas fa-angle-up fa-lg ' : 'fas fa-angle-down fa-lg '}`}></span>
            </div>
          </div>
        : <></>}
        {props.view !== "DashboardCustomer" || toggleItem[0] === props._id ?
          <>
            <hr/>
            <form onSubmit={handleSubmit}>
              <div className="row v-center">
                <div className="col-12">
                  <div className="row v-center">
                    {/*<div className="form-group col-md-4 col-12">
                      <label className="switch itemDashboardListSwitch">
                        <input type="checkbox" value={stateActive} checked={stateActive} onChange={() => setStateActive(!stateActive)} />
                        <div className="slprops.ider"></div>
                      </label>
                      <label className="labelImage">Imagem do Canal:</label>
                      <label id="thumbnailCustomer" style={{ backgroundImage: `url("${preview}")` }} className={formState.thumbnail ? 'has-thumbnail' : ''}>
                        <input type="file" onChange={onChangeThumbnailFile} />
                        <img src={camera} alt="Select img" />
                      </label>
                    </div>
                    */}
                    <div className="form-group col-md-6 col-12">
                      {props.view === "EvaluateIris" && !formState._id.toString().match(/^[0-9a-fA-F]{24}$/) ?
                      <>
                        <DatalistInput
                          required 
                          autoFocus
                          autocomplete="one-time-code"
                          placeholder={t('customer.form.selectCustomer')}
                          label={t('customer.form.selectCustomer')}
                          labelProps={{className:"labelInput"}}
                          inputProps={{className:"form-control"}}
                          onSelect={onSelectCustomer}
                          items={allCustumers}
                          value={formState.name}
                          onChange={event => {
                            setFormState({...formState, name: event.target.value}); 
                            props.setCanEditCustomer(true);
                          }}
                        />
                      </>
                      :
                      <>
                        <label className="labelInput">{t('customer.form.name')}</label>
                        <input
                          required 
                          autoFocus
                          disabled={props.canEditCustomer ? "" : "disabled"}
                          type="text" 
                          className="form-control" 
                          placeholder={t('customer.form.namePlaceholder')}
                          value={formState.name}
                          onChange={event => setFormState({...formState, name: event.target.value}) }
                        />
                      </>
                      }
                    </div>
                    <div className="form-group col-md-2 col-4">
                      <label className="labelInput">{t('customer.form.gender')}</label>
                      <select className="form-control" disabled={props.canEditCustomer ? "" : "disabled"} value={formState.gender} onChange={event => setFormState({...formState, gender: event.target.value })} >
                        <option value="">{t('common.select')}</option>
                        <option key={"M"}>{t('common.male')}</option>
                        <option key={"F"}>{t('common.female')}</option>
                        <option key={"O"}>{t('common.other')}</option>
                      </select>
                    </div>
                    <div className="form-group col-md-4 col-8">
                      <label className="labelInput">{t('customer.form.bloodType')}</label>
                      <select className="form-control" disabled={props.canEditCustomer ? "" : "disabled"} value={formState.bloodType} onChange={event => setFormState({...formState, bloodType: event.target.value })} >
                        <option value="">{t('common.select')}</option>
                        <option key={"A+"}>A+</option>
                        <option key={"A-"}>A-</option>
                        <option key={"B+"}>B+</option>
                        <option key={"B-"}>B-</option>
                        <option key={"AB+"}>AB+</option>
                        <option key={"AB-"}>AB-</option>
                        <option key={"O+"}>O+</option>
                        <option key={"O-"}>O-</option>
                      </select>
                    </div>
                    <div className="form-group col-md-4 col-12">
                      <label className="labelInput">{t('customer.form.birthDate')}</label>
                      <InputMask
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        mask="99/99/9999" 
                        type="text" 
                        className="form-control" 
                        placeholder={t('customer.form.birthDatePlaceholder')}
                        value={formState.birthDate}
                        onChange={event => setFormState({...formState, birthDate: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-6">
                      <label className="labelInput">{countryConfig.documents.individual.name}</label>
                      <InputMask
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        mask={countryConfig.documents.individual.mask}
                        type="text" 
                        className="form-control" 
                        placeholder={countryConfig.documents.individual.name}
                        value={formState.cpf}
                        onChange={event => setFormState({...formState, cpf: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-6">
                      <label className="labelInput">{t('customer.form.phone')}</label>
                      <InputMask 
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        mask={countryConfig.phone.mask}
                        className="form-control" 
                        placeholder={t('customer.form.phonePlaceholder')}
                        value={formState.phone}
                        onChange={event => setFormState({...formState, phone: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-6">
                      <label className="labelInput">{t('customer.form.height')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="number" 
                        className="form-control" 
                        placeholder={t('customer.form.heightPlaceholder')}
                        value={formState.height}
                        onChange={event => setFormState({...formState, height: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-6">
                      <label className="labelInput">{t('customer.form.weight')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="number" 
                        className="form-control" 
                        placeholder={t('customer.form.weightPlaceholder')}
                        value={formState.weight}
                        onChange={event => setFormState({...formState, weight: event.target.value}) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-12">
                      <label className="labelInput">{t('customer.form.IMC')}</label>
                      <input
                        disabled="disabled"
                        type="number" 
                        className="form-control" 
                        placeholder={t('customer.form.IMC')}
                        value={parseFloat(parseFloat(formState.weight) / (parseFloat(formState.height) * parseFloat(formState.height))).toFixed(2)}
                      />
                    </div>
                    <div className="form-group col-md-8 col-8">
                      <label className="labelInput">{t('customer.form.address')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="text" 
                        className="form-control" 
                        placeholder={t('customer.form.addressPlaceholder')}
                        value={formState.address.street}
                        onChange={event => setFormState({...formState, address: {...formState.address, street: event.target.value} }) }
                      />
                    </div>
                    <div className="form-group col-md-4 col-4">
                      <label className="labelInput">{t('customer.form.number')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="number" 
                        className="form-control" 
                        placeholder={t('customer.form.numberPlaceholder')}
                        value={formState.address.number}
                        onChange={event => setFormState({...formState, address: {...formState.address, number: event.target.value} }) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('customer.form.district')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="text" 
                        className="form-control" 
                        placeholder={t('customer.form.districtPlaceholder')}
                        value={formState.address.district}
                        onChange={event => setFormState({...formState, address: {...formState.address, district: event.target.value} }) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('customer.form.complement')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="text"
                        className="form-control" 
                        placeholder={t('customer.form.complementPlaceholder')}
                        value={formState.address.complement}
                        onChange={event => setFormState({...formState, address: {...formState.address, complement: event.target.value} }) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('customer.form.city')}</label>
                      <input
                        disabled={props.canEditCustomer ? "" : "disabled"}
                        type="text" 
                        className="form-control" 
                        placeholder={t('customer.form.cityPlaceholder')}
                        value={formState.address.city}
                        onChange={event => setFormState({...formState, address: {...formState.address, city: event.target.value} }) }
                      />
                    </div>
                    <div className="form-group col-md-6 col-12">
                      <label className="labelInput">{t('customer.form.state')}</label>
                      <select 
                        className="form-control" 
                        disabled={props.canEditCustomer ? "" : "disabled"} 
                        value={formState.address.state} 
                        onChange={event => setFormState({...formState, address: {...formState.address, state: event.target.value} })}
                      >
                        <option value="">{t('common.select')}</option>
                        {countryConfig.address.state.options.map((state) => (
                          <option key={state} value={state}>{state}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="form-group col-12">
                          <label className="labelInput">{t('customer.form.observations')}</label>
                          <textarea 
                            disabled={props.canEditCustomer ? "" : "disabled"}
                            className="form-control" 
                            rows="3" 
                            value={formState.observations}
                            onChange={event => setFormState({...formState, observations: event.target.value}) }
                          />
                        </div>
                      </div>
                      {props.view === "EvaluateIris" && formState.name !== "" && !formState._id.toString().match(/^[0-9a-fA-F]{24}$/) ?
                        <div style={{marginLeft: 5}}>
                          <span style={{color: 'red'}}>{t('customer.form.newPatient')}</span>
                        </div>
                      :<></>}
                    </div>
                  </div>     
                </div>     
                <div className="col-12 text-right">
                  {props?.onDelete && <button type="button" className="btn btn-delete" onClick={props.onDelete}> {t('customer.form.delete')} </button> }
                  <span>&nbsp;&nbsp;&nbsp;</span>
                  {formState._id.toString().match(/^[0-9a-fA-F]{24}$/) ?
                    props.canEditCustomer ?
                      <button type="submit" className="btn btn-default"> {t('customer.form.save')} </button>
                    : <></>
                  : 
                    <button type="submit" className="btn btn-default"> {t('customer.form.save')} </button>
                  }
                </div>
              </div>
            </form>
          </>
        : '' }
      </li>
  );
};

export default ListItemCustomer;
